import ajax from './ajax';
import config from '../config';
import url from './url';

let request = function(options, ignore) {
  return import('../default/data').then(data => {
    options = Object.assign(
      {
        method: 'get',
        dataType: 'json',
        credentials: 'omit'
      },
      options
    );
    let realUrl = options.url || '';
    if (realUrl.indexOf('//') < 0) {
      let prefix = '';
      // v2的接口都是用apiV2
      if (
        realUrl.indexOf('/api/v2') === 0 ||
        realUrl.indexOf('/api/v3') === 0
      ) {
        prefix = config.apiV2;
      } else {
        prefix = config.api;
      }
      realUrl = prefix + realUrl;
      options.url = realUrl;
    }

    const urlobj = url(options.url);

    options.url = urlobj.toString();

    return ajax(options);
  });
};

request.domain = '';
request.wx = window.__hostname;
request.token = '';

export default request;
